<template>
  <div style="height:100%;">
    <b-container class="base-container">
      <topbar :isLoading="isLoading"></topbar>
      <div class="app-main-container">
        <sidebar :isLoading="isLoading"></sidebar>
        <div class="stage" id="stage">
          <iwpnavbar :isLoading="isLoading"></iwpnavbar>
          <router-view class="stage-content" v-if="!isLoading"></router-view>
          <div class="stage-loading-wrapper" v-if="isLoading">
            <div class="main-loading-logo logo">
              <logo class="logo-svg"></logo>
            </div>
            <div class="main-loading-title">
              Admin Panel v{{appVersion}}
            </div>
            <div class="main-loading-progress">
              <b-progress :value="value" :max="max" class="custom"></b-progress>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <processqueue v-if="!isLoading"></processqueue>
    <notifications group="foo">
      <template slot="body" slot-scope="props">
        <div class="notification-item " v-bind:class="props.item.type">
          <a class="notification-title">
            <success-icon class="icon-default success" v-if="props.item.type==='N'"></success-icon>
            <error-icon class="icon-default error" v-if="props.item.type==='E'"></error-icon>
            <warning-icon class="icon-default warning" v-if="props.item.type==='W'"></warning-icon>
            <span>{{props.item.title}}</span>
          </a>
          <a class="close" @click="props.close">
            <close-icon class="icon-default close" v-bind:class="props.item.type"></close-icon>
          </a>
          <div class="notification-content" v-html="props.item.text">
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import logo from '../assets/logo.svg';
import CloseIcon from '../assets/close.svg';
import SuccessIcon from '../assets/success.svg';
import ErrorIcon from '../assets/error.svg';
import WarningIcon from '../assets/warning.svg';

import Vue from 'Vue';
import routes from '../router/routes';
import _ from 'lodash';
import Utils from '../mixins/utils';
export default {
  name: 'home',
  components: {
    CloseIcon,
    SuccessIcon,
    ErrorIcon,
    WarningIcon,
    logo
  },
  mixins: [Utils],
  data() {
    return {
      routes: routes[0].children,
      isLoading: true,
      max: 100,
      value: 33.333333333,
      appVersion: window.appVersion
    };
  },
  mounted() {
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "N",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "W",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
    // this.$notify({
    //   group: "foo",
    //   title: "Important message",
    //   type: "E",
    //   text: "Hello user! This is a notification!",
    //   duration: -1
    // });
  },
  created() {
    this.value = 0;
    this.$store
      .dispatch({
        type: 'getInit'
      })
      .then(() => {
        this.value = 50;
        let payload = {};
        payload.requiredData = {
          getInstalledAddonsV3: 1
        };
        this.$store.dispatch('sendAction', payload).then(response => {
          this.$store.commit(
            'SET_INSTALLED_ADDONS',
            response.data.getInstalledAddonsV3
          );
          // let addons = response.data.getInstalledAddonsV3;
          // _.each(addons, slug => {
          //   this.loadAddon(slug).then(module => {
          //     if (module && module.default && module.default.Store) {
          //       this.$store.registerModule(slug, module.default.Store);
          //     }

          //     //return module.default.Component;
          //   });
          // });
          this.value = 100;
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        });
      })
      .catch(err => {
        
      });

    window.eventHub.$on('sendNotification', event => {
      this.processNotification(event.notifications);
    });
  },
  methods: {
    processNotification(notifications) {
      _.each(notifications, notification => {
        this.$notify({
          group: 'foo',
          title: notification.title,
          type: notification.type,
          text: notification.message,
          duration: -1
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Home.vue